import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { RefundMeasManagerDecision, FormMode, Languages, ServiceStatus, RefundEunitApprovalDecision } from 'src/app/shared/models/enums.model';
import { ReleaseRefundRequestDTO, ReleaseRefundAdminDTO } from 'src/app/shared/models/long-haul.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';

@Component({
  selector: 'app-eunit-approval',
  templateUrl: './eunit-approval.component.html'
})
export class EunitApprovalComponent {
  submitted = false;
  loading = false;
  showRequest: boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  refundRequestObj: ReleaseRefundRequestDTO = new ReleaseRefundRequestDTO();
  refundAdminObj: ReleaseRefundAdminDTO = new ReleaseRefundAdminDTO();
  decision = RefundEunitApprovalDecision;
  decisionKeys = Object.keys(this.decision);
  displayedLang: string;
  decisionValue: number;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  baseRequestId: string = '';
  user: User = new User();
  refundEunitApprovalForm: FormGroup;
  responseObj: ResponseObject = new ResponseObject();
  requestStatus: number;
  @Input() public isShow: boolean = true;
  isLoaded: boolean = false;
  eunitSignedUsersCount: number;
  showProceedToManagers: boolean = false;
  showRestudyDecision: boolean = false;



  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private longhaulserv: LongHaulService) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getRequest();
    } else {
      window.history.back();
    }
    this.user = this.globalSrv.user;
  }
  ngOnInit() {
    this.buildForm(null);
  }

  buildForm(decision) {
    this.refundEunitApprovalForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });
    if (decision == RefundMeasManagerDecision.MeasManager_Approve) {
      this.refundEunitApprovalForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
      });
    }
    else if (decision == RefundMeasManagerDecision.MeasManager_MoreInformation) {
      this.refundEunitApprovalForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required]],
      });
    }
  }
  get form() {
    return this.refundEunitApprovalForm.controls;
  }

  changeDecision(value) {
    this.buildForm(value);
    this.refundEunitApprovalForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
  }

  getRequest() {
    this.longhaulserv.GetRefundRequestById(this.baseRequestId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.refundRequestObj = this.responseObj.Data;
          this.requestStatus = this.refundRequestObj.BaseRequest.StatusId;
          this.eunitSignedUsersCount = this.refundRequestObj.EunitSignedUsersCount || 0;
          if (this.eunitSignedUsersCount >= 2) {
            this.showProceedToManagers = true;
          }
          this.isLoaded = true;
          if (this.refundRequestObj.ReleaseRestudyRequestId != null) {
            this.showRestudyDecision = true;
          }
          if (history.state.data && history.state.data.isCompleted) {
            this.decisionValue = this.refundRequestObj.EunitDecision;
            if (this.refundRequestObj.EunitDecision == RefundEunitApprovalDecision.EunitApproval_MoreInformation) {
              this.buildForm(this.decisionValue);
              this.refundEunitApprovalForm.patchValue({
                Decision: this.decisionValue ,
                MoreInformation: this.refundRequestObj.EunitNotes
              });
            }
            else {
              this.buildForm(this.decisionValue);
              this.refundEunitApprovalForm.patchValue({
                Decision: this.decisionValue,
              });
            }
            this.formMode = FormMode.Readonly;
            this.refundEunitApprovalForm.disable();
          }
          else if(this.requestStatus == ServiceStatus.Refund_PendingEconomicCommitteeApproval){
            this.formMode = FormMode.Add;
            this.refundEunitApprovalForm.enable();
          }
          else{
            this.formMode = FormMode.Readonly;
            this.refundEunitApprovalForm.disable();
            this.decisionValue = this.refundRequestObj.EunitDecision;
            if (this.refundRequestObj.EunitDecision == RefundEunitApprovalDecision.EunitApproval_MoreInformation) {
              this.buildForm(this.decisionValue);
              this.refundEunitApprovalForm.patchValue({
                Decision: this.decisionValue ,
                MoreInformation: this.refundRequestObj.EunitNotes
              });
            }
            else {
              this.buildForm(this.decisionValue);
              this.refundEunitApprovalForm.patchValue({
                Decision: this.decisionValue,
              });
            }

          }
        }
      }
    )
  }

  onSubmit(proceedToManagers: boolean) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.refundEunitApprovalForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.refundAdminObj.AdminEmail = this.user.UserName;
    this.refundAdminObj.Id = this.baseRequestId;
    this.refundAdminObj.EunitDecision = this.decisionValue;
    if (this.decisionValue == RefundEunitApprovalDecision.EunitApproval_MoreInformation) {
      this.refundAdminObj.EunitNotes = this.refundEunitApprovalForm.controls.MoreInformation.value;
    } else {
      this.refundAdminObj.EunitSignedUsersCount = this.eunitSignedUsersCount + 1;
    }
    if (proceedToManagers) {
      this.refundAdminObj.ProceedToManagers = true;
    }

    this.longhaulserv.SubmitRefundEunitApprovalDecision(this.refundAdminObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.refundEunitApprovalForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }
}
